<template>
  <div class="page-content">
    <!-- Grid sem container limitador -->
    <div
      class="sample1 grid middle"
      @keyup.46="$bvModal.show('confirmDeleteData')"
    ></div>
    <div class="row gridBtGroup rowItem" xl="1" lg="3" md="3" sm="3">
      <img
        src="@/assets/excluir.png"
        :alt="$t('excluir')"
        style="margin-left: 30px; height:38px"
        :title="$t('excluir')"
        @click="$bvModal.show('confirmDeleteData')"
      />
      <img
        src="@/assets/salvar.png"
        :alt="$t('salvar')"
        style="margin-left: 30px; height:38px"
        :title="$t('salvar')"
        @click="sendEquipments()"
      />
      <img
        src="@/assets/cancel.png"
        :alt="$t('cancelar')"
        style="margin-left: 30px; height:38px"
        :title="$t('cancelar')"
        @click="$bvModal.show('confirmResetData')"
      />
    </div>

    <b-modal
      id="confirmResetData"
      :title="$t('atencao')"
      ok-variant="danger"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      @ok="reset"
    >
      {{ $t('confirma-o-descarte-das-alteracoes-0') }}
    </b-modal>

    <b-modal
      id="confirmDeleteData"
      :title="$t('atencao')"
      ok-variant="danger"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      @ok="del"
    >
      {{ $t('deseja-excluir-o-s-equipamento-s-selecionados') }}
    </b-modal>

    <b-modal
      id="DeletionNotAllowed"
      size="md"
      hide-footer
      :title="$t('atencao')"
      :no-close-on-backdrop="true"
    >
      <MessageBox :info="deletionNotAllowed" modelname="DeletionNotAllowed" />
    </b-modal>
  </div>
</template>

<script>
import * as cGridAll from "vue-cheetah-grid";
import * as cheetahGrid from "cheetah-grid";
import { defaultSuccess, urlMainAPI, showError } from "@/global";
import MessageBox from "@/components/template/MessageBoxModal.vue";
import axios from "axios";

var inputEditor = new cheetahGrid.columns.action.InlineInputEditor();
var processEditor = new cheetahGrid.columns.action.InlineMenuEditor({
  options: [],
  onSelect: () => {
    processEditor.close();
  }
});

inputEditor.disabled = (record) => {
  if (record != null || record != undefined) {
    return false;
  }
};

const { CLICK_CELL, PASTE_CELL, INPUT_CELL } = cheetahGrid.ListGrid.EVENT_TYPE;

export default {
  description: "GridEquipments",
  components: {
    ...cGridAll,
    MessageBox
  },
  watch: {
    json() {},
  },
  data: function () {
    return {
      temp: [],
      grid: "",
      currentLine: 0,
      json: [],
      processes: [],
      deletionNotAllowed: "",
      header: [
        {
          field: "description",
          caption: this.$t('equipamentos'),
          action: inputEditor,
          width: "50%",
          maxWidth: "50%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse" },
        },
        {
          field: "process",
          caption: this.$t('processos'),
          action: processEditor,
          width: "50%",
          maxWidth: "50%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse" },
          formatter: (record) => {
            const process = this.processes.find(p => p.id === record.process);
            return process ? process.description : '';
          }
        }
      ],
    };
  },
  methods: {
    loadEquipments() {
      defaultSuccess(this.$t('carregando-equipamentos'));
      const url = `${urlMainAPI}/getequipments`;
      axios
        .get(url)
        .then((res) => {
          this.json = res.data.length == 0 ? [{ description: "", processId:""}] : res.data;
      
          this.json.forEach(item => {
            item.process = item.processId;
            const process = this.processes.find(p => p.id === item.processId);
            if (process) {
              item.process = process.description;
            }
          });

          this.temp = JSON.parse(JSON.stringify(this.json));
          this.maintainExtraLines();
          this.setGrid();
          defaultSuccess(this.$t('equipamentos-carregados'));
        })
        .catch();
    },

    loadProcesses() {
      const url = `${urlMainAPI}/getprocess`;
      axios
        .get(url)
        .then((res) => {
          this.processes = res.data;
          processEditor.options = this.processes.map(p => ({
            value: p.id,
            caption: p.description
          }));
        })
        .catch();
    },

    createGrid() {
      const grid = new cheetahGrid.ListGrid({
        parentElement: document.querySelector(".sample1"),
        allowRangePaste: true,
        header: this.header,
      });
      grid.records = this.json;

      grid.listen(cheetahGrid.ListGrid.EVENT_TYPE.CHANGED_VALUE, (...args) => {
        if (args[0].col === 1) {
          const record = this.json[args[0].row - 1];
          if (record) {
            const process = this.processes.find(p => p.id === record.process);
            if (process) {
              record.processId = process.id;
              record.process = process.description;
              this.setGrid();
            }
          }
        }
      });

      grid.listen(INPUT_CELL, (...args) => {
        if (
          args[0].row == this.json.length &&
          !this.json[this.json.length - 1].description
        ) {
          this.addLine();
          this.setGrid();
        }
      });

      grid.listen(CLICK_CELL, (...args) => {
        this.currentLine = args[0].row;
        let hasData = this.json[this.json.length - 1].description
          ? this.json[this.json.length - 1].description.trim()
            ? true
            : false
          : false;

        if (args[0].row == this.json.length && hasData) {
          this.addLine();
          this.setGrid();
        }
      });

      grid.listen(PASTE_CELL, async (...args) => {
        let lines = args[0].normalizeValue.split("\r\n");
        let temp2 = lines;
        let countTable = this.json.length;
        if (this.currentLine == 1) {
          if (countTable < lines.length) {
            let dif = lines.length - countTable;
            for (let i = 0; i <= dif; i++) {
              this.addLine(lines[countTable + i]);
            }
          }
        } else if (
          this.currentLine == this.json.length ||
          this.currentLine == this.json.length - 1
        ) {
          this.clearEmptyLines();
          let calc = temp2.length + (this.json.length - this.currentLine);
          for (let i = 0; i <= calc; i++) {
            this.addLine(temp2[i]);
          }
          this.addLine();
        }
        this.maintainExtraLines();
        this.setGrid();
      });

      this.setGrid = function (table = this.json) {
        grid.records = table;
      };

      this.json = grid.records;
      this.grid = grid;
      this.maintainExtraLines();
    },

    clearEmptyLines() {
      let count = this.json.length - this.currentLine + 1;
      for (let i = 0; i < count; i++) this.json.pop();
    },

    addLine(param) {
      this.json.push({ id: "", description: param || "", process: ""});
    },

    maintainExtraLines() {
      const lastDataIndex = this.json.findLastIndex(item => item.description.trim() || item.processId);
      
      if (lastDataIndex === -1) {
        while (this.json.length < 5) {
          this.addLine();
        }
        return;
      }

      const currentExtraLines = this.json.length - (lastDataIndex + 1);
      const neededExtraLines = 5 - currentExtraLines;

      if (neededExtraLines > 0) {
        for (let i = 0; i < neededExtraLines; i++) {
          this.addLine();
        }
      } else if (neededExtraLines < 0) {
        this.json.splice(lastDataIndex + 6);
      }
    },

    async sendEquipments() {
      defaultSuccess(this.$t('salvando-dados'));
      
      const emptyEquipments = this.json.filter(d => !d.description.trim() && d.processId);
      if (emptyEquipments.length > 0) {
        showError(`Processo sem equipamento vinculado.`);
        return;
      }

      let equipmentList = await this.json.map((d) => {
        return {
          id: d.id ? d.id : 0,
          description: d.description,
          processId: d.processId || null
        };
      });

      const url = `${urlMainAPI}/saveequipments`;
      await axios
        .post(url, equipmentList)
        .then((res) => {
          const savedEquipments = res.data;
          this.json.forEach((equipment) => {
            const savedEquipment = savedEquipments.find(e => 
              e.description === equipment.description && 
              e.processId === (equipment.processId ? parseInt(equipment.processId) : null)
            );
            if (savedEquipment) {
              equipment.id = savedEquipment.id;
            }
          });
          
          this.temp = JSON.parse(JSON.stringify(this.json));
          defaultSuccess(this.$t('equipamento-s-salvo-s-com-sucesso'));
          this.maintainExtraLines();
        })
        .catch();

      this.setGrid();
    },

    reset() {
      this.json = JSON.parse(JSON.stringify(this.temp));
      this.setGrid(this.json);
      defaultSuccess(this.$t('alteracoes-descartadas'));
    },

    del() {
      let indexFirstElement = this.grid.selection._start.row - 1;
      let equipmentsToDelete = this.json.slice(
        indexFirstElement,
        this.grid.selection._end.row
      );

      equipmentsToDelete = equipmentsToDelete.map(p => {
        if (p.id == '') {
          return { id: 0, description: p.description }
        }
        return p
      })

      const url = `${urlMainAPI}/deleteequipments`;

      axios
        .post(url, equipmentsToDelete)
        .then(async (res) => {
          let equipmentsNotDelete = res.data.equipmentsNotDelete;
          if (equipmentsNotDelete.length > 0) {
            let text = `O(s) equipamento(s):`;
            equipmentsNotDelete.forEach((eq) => {
              text += ` ${eq.description == '' ? '[vazio]' : eq.description}; `; 
            });
            text += `não pode(m) ser removido(s),`;
            text += ` pois possui(em) configuração de grandeza.`;
            this.deletionNotAllowed = text;
            this.$bvModal.show("DeletionNotAllowed");
          } else {
            defaultSuccess(this.$t('equipamento-s-removido-s-com-sucesso'));
          }
          await this.removeDeletedEquipments(equipmentsToDelete, equipmentsNotDelete);
        })
        .catch();
    },

    async removeDeletedEquipments(equipmentsToDelete, equipmentsNotDelete) {
      let remove = new Array();
      await equipmentsToDelete.forEach((p) => {
        let pFounded = equipmentsNotDelete.find((p2) => p2.id == p.id);
        if (pFounded == null) remove.push(p);
      });
      remove.forEach((p) => {
        let index = this.json.findIndex((p2) => p2.id == p.id);
        this.json.splice(index, 1);
      });
      this.temp = JSON.parse(JSON.stringify(this.json));
      this.setGrid();
    },
  },

  async created() {
    await this.loadProcesses();
    await this.loadEquipments();
  },

  mounted() {
    this.createGrid();
  },
};
</script>

<style scoped>
/* Oculta todas as barras de rolagem em todos os elementos do componente */
:deep(*::-webkit-scrollbar) {
  display: none;
}

:deep(*) {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.sample1 {
  width: 90%;
  max-width: 1400px;
  height: 100vh;
  border: solid 1px rgba(0, 0, 0, 0.26);
  margin: 0 auto;
  overflow-x: hidden;
  overflow-y: auto;
}

.row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
}

.group {
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}

.gridBtGroup {
  margin: 30px auto;
  width: 90%;
  max-width: 1400px;
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
}

.ybase {
  margin-top: 20px;
}

.gridBtGroup img {
  cursor: pointer;
  max-height: 45px;
}
</style>